export const DATA_LOCATION = {
  CREATE_DATA_LOCATION: 'CREATE_DATA_LOCATION',
  CREATE_DATA_LOCATION_ERROR: 'CREATE_DATA_LOCATION_ERROR',
  CREATE_DATA_LOCATION_SUCCESS: 'CREATE_DATA_LOCATION_SUCCESS',
  CREATE_DATA_LOCATION_RESET: 'CREATE_DATA_LOCATION_RESET',
  FETCH_DATA_LOCATIONS: 'FETCH_DATA_LOCATIONS',
  FETCH_DATA_LOCATIONS_ERROR: 'FETCH_DATA_LOCATIONS_ERROR',
  FETCH_DATA_LOCATIONS_SUCCESS: 'FETCH_DATA_LOCATIONS_SUCCESS',
};
